import React from "react";
import {
  IconWrapper,
  CheckmarkIcon,
  SpinnerIcon,
  PendingDot,
} from "./styles";

interface AnimatedStatusIconProps {
  status: "pending" | "loading" | "completed";
  required?: boolean;
}

export function AnimatedStatusIcon({ status, required = true }: AnimatedStatusIconProps) {
  if (status === "completed") {
    return (
      <IconWrapper $status={status} data-testid="status-icon-completed">
        <CheckmarkIcon viewBox="0 0 18 18" aria-label="Completed">
          <circle cx="9" cy="9" r="9" />
          <path d="M5 9l3 3 5-6" />
        </CheckmarkIcon>
      </IconWrapper>
    );
  }

  if (status === "loading") {
    return (
      <IconWrapper $status={status} data-testid="status-icon-loading">
        <SpinnerIcon viewBox="0 0 18 18" aria-label="Loading">
          <circle cx="9" cy="9" r="7" />
        </SpinnerIcon>
      </IconWrapper>
    );
  }

  return (
    <IconWrapper $status={status} data-testid="status-icon-pending">
      <PendingDot $required={required} aria-label="Pending" />
    </IconWrapper>
  );
}

export default AnimatedStatusIcon;
